<template>
  <div class="header11">
    <div class="nav">
      <div class="w">
        <div class="left">
          <!-- <img src="../../assets/index/nav_icon/Adress.png" />
          <a href="javascript:;">河南</a>-->
          <span>你好，欢迎光临!</span>
        </div>
        <div class="right">
          <ul class="item">
            <li class="btnGuoup" v-if="flag==false">
              <a href="javascript:;" @click="goLogin()">登陆</a>|
              <a href="javascript:;" @click="goregister()">注册</a>
            </li>
            <li v-else>
              <router-link to="/userinfo">
                <img
                  style="width:20px;cursor:pointer;margin-right:5px;border-radius: 50%;"
                  :src="avatar"
                />
              </router-link>
              <router-link to="/userinfo" style="margin-right:10px">{{nickname}}</router-link>
              <a href="javascript:;" @click="exit()">退出</a>
            </li>
            <li>
              <router-link to="/systemnew">消息中心</router-link>
            </li>
            <li class="c-item">
              <a href="javascript:;">
                <router-link to="/user">我的订单</router-link>
              </a>

              <img src="../../assets/index/nav_icon/arrow_down.png" />
              <!-- <div class="drapdown dd">
                <ul class="dd-inner">
                  <li>
                    <a href="javascript:;">待处理订单</a>
                    <span>5</span>
                  </li>
                  <li>
                    <a href="javascript:;">未完成订单</a>
                    <span>2</span>
                  </li>
                  <li>
                    <a href="javascript:;">我关注的商品</a>
                    <span>12</span>
                  </li>
                </ul>
              </div>-->
            </li>
            <li class="c-item sy_fw">
              <a href="javascript:;">服务中心</a>
              <img src="../../assets/index/nav_icon/arrow_down.png" />
              <div class="drapdown2 dd">
                <div class="dd_inner2">
                  <ul class="clearfix">
                    <template v-for="(item,index) in cateNewData">
                      <li :key="index">
                        <a href="javascript:;" @click="goNew(item)">{{item.title}}</a>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </li>
            <li class="c-item sy_dh">
              <a href="Javascript:;">网站导航</a>
              <img src="../../assets/index/nav_icon/arrow_down.png" />
              <div class="drapdown3 dd">
                <ul class="dd_inner">
                  <li v-for="(item,index) in headerList" :key="index">
                    <a href="javascript:;" v-if="item.remark===''">{{item.title}}</a>
                    <a
                      v-else-if="item.remark.includes('http')"
                      :href="item.remark"
                      target="_blank"
                    >{{item.title}}</a>
                    <router-link v-else :to="item.remark">{{item.title}}</router-link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- <div id="search">
      <div class="w">
        <div class="search_logo">
          <a href="javascript:;">
            <img src="../../assets/images/logo.png" alt="云闪印" title="云闪印" />
          </a>
        </div>
        <div class="search_box">
          <input type="text" placeholder="请输入您要搜索的信息" />
          <button class="search-button"></button>
        </div>
        <div class="search-design">
          <button>
            <img src="../../assets/index/nav_icon/logo-design.png" />
            <span>logo设计</span>
          </button>
        </div>
        <div class="search-shopCar">
          <i class="shop-icon"></i>
          <span>我的购物车</span>
          <div class="cartList" style="display: none;">
            <div class="empty_cart">
              <div class="cart_pop">
                <img src="../../assets/index/nav_icon/empty_cart.png" class="cart_img" />
                <span>购物车中还没有商品，赶紧选购吧！</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'header11',
  data() {
    return {
      flag: true,
      nickname: '',
      avatar: '',
      headerList: {},
      cateNewData: [],
      fwFlag: true,
      dhFlag: true
    }
  },
  created() {
    const bool = window.localStorage.getItem('token')
    if (!bool) {
      return (this.flag = false)
    }
    let userInfo = window.localStorage.getItem('u')
    if (userInfo) {
      this.avatar = JSON.parse(userInfo).avatar
    }
    this.flag = true
  },
  methods: {
    // 退出
    exit() {
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('u')
      this.$router.push('/login')
    },
    goLogin() {
      this.$router.push('/login')
    },
    goregister() {
      this.$router.push('/register')
    },
    // 获取header数据
    async queryList() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: '/api/page/nav',
        data: param
      })
      JSON.stringify(res.data) !== []
        ? (this.headerList = res.data)
        : (this.headerList = {})
    },
    async queryCateNews() {
      this.cateNewData = []
      const { data: res } = await this.$http.get('api/index/getnewscate')
      if (res.code) {
        for (let k in res.data) {
          for (let i = 0; i < res.data[k].list.length; i++) {
            this.cateNewData.push(res.data[k].list[i])
          }
        }
      }
    },
    goNew(item) {
      window.sessionStorage.setItem('n', item.title)
      this.$router.push('/newList?id=' + item.id)
    }
  },
  mounted() {
    $('.sy_fw').mouseenter(() => {
      if (this.fwFlag) {
        this.queryCateNews()
        this.fwFlag = false
      }
    })
    $('.sy_dh').mouseenter(() => {
      if (this.dhFlag) {
        this.queryList()
        this.dhFlag = false
      }
    })
    if (window.localStorage.getItem('u')) {
      let u = window.localStorage.getItem('u')
      this.nickname = JSON.parse(u).nickname
    }
    $('ul.item .c-item').hover(function() {
      $(this)
        .children('.dd')
        .stop()
        .fadeToggle(200)
    })
    $('.search-shopCar').hover(function() {
      $(this)
        .children('.cartList')
        .stop()
        .fadeToggle(200)
    })
  }
}
</script>

<style lang="less" scoped>
.nav {
  height: 35px;
  background: #eef2f5;
  .w {
    div {
      display: inline-block;
    }
    .left {
      line-height: 35px;
      a {
        margin-left: 5px;
      }
      span {
        margin-left: 20px;
      }
    }
    .right {
      float: right;
      .item {
        line-height: 35px;
        li {
          position: relative;
          padding: 0 6px;
          float: left;
          margin-right: 20px;
          a {
            vertical-align: middle;
            margin-right: 3px;
          }
        }
      }
    }
    .drapdown {
      display: none;
      z-index: 999;
      position: absolute;
      top: 36px;
      left: 0;
      width: 150px;
      height: 80px;
      background-color: #fff;
      .dd-inner {
        background-color: #fff;
        width: 100%;
        li {
          background-color: #fff;
          box-sizing: border-box;
          padding: 5px 12px !important;
          height: 30px;
          width: 100%;
          line-height: 30px;
          font-size: 12px;
          color: #666666;
          cursor: pointer;
          span {
            color: #e83030;
          }
        }
        li:hover {
          background: #edfff6;
          color: #a77c5a;
        }
      }
    }
    .drapdown2 {
      display: none;
      position: absolute;
      top: 36px;
      left: 0;
      background: #fff;
      z-index: 999;
      .dd_inner2 {
        width: 76px;
        height: 110px;
        background: #fff;
        ul {
          li {
            box-sizing: border-box;
            padding-left: 10px;
            width: 76px;
            height: 24px;
            line-height: 24px;
            font-size: 12px;
            color: #666;
            background: #fff;
            cursor: pointer;
          }
          li:hover {
            background: #edfff6;
            color: #a77c5a;
          }
        }
      }
    }
    .drapdown3 {
      display: none;
      position: absolute;
      top: 36px;
      left: 0;
      background: #fff;
      z-index: 999;
      .dd_inner {
        width: 76px;
        height: 85px;
        li {
          box-sizing: border-box;
          padding-left: 10px;
          width: 76px;
          height: 24px;
          line-height: 24px;
          cursor: pointer;
          font-size: 12px;
          color: #666;
        }
        li:hover {
          background: #edfff6;
          color: #a77c5a;
        }
      }
    }
  }
}
#search {
  display: none;
  position: fixed;
  z-index: 9999999;
  top: 0;
  height: 60px;
  width: 100%;
  background-color: #fff;
  .w {
    position: relative;
    height: 100%;
    .search_box {
      position: absolute;
      left: 323px;
      top: 10px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border: 2px solid #a77c5a;
      width: 480px;
      height: 44px;
      padding: 10px 20px;
      margin-right: 10px;
      input {
        height: 100%;
        width: 85%;
        font-size: 14px;
      }
      .search-button {
        position: absolute;
        top: 0;
        right: 0;
        width: 15%;
        height: 40px;
        background: url('../../assets/index/nav_icon/search.png') no-repeat
          center #a77c5a;
      }
    }
    .search-design {
      position: absolute;
      top: 11px;
      right: 265px;
      width: 118px;
      height: 40px;
      border: 1px solid #a77c5a;
      button {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        color: #a77c5a;
        font-size: 16px;
        background-color: #fff;
        img {
          margin-right: 8px;
        }
      }
    }
    .search-shopCar {
      position: relative;
      position: absolute;
      display: flex;
      box-sizing: border-box;
      top: 11px;
      right: 78px;
      width: 148px;
      height: 40px;
      border: 1px solid #ddd;
      padding: 11px 18px;
      font-size: 14px;
      color: #666;
      cursor: pointer;
      .shop-icon {
        width: 17px;
        height: 17px;
        background: url('../../assets/index/nav_icon/shop-cart.png');
        margin-right: 7px;
      }
      .shop-count {
        position: absolute;
        top: 5px;
        right: 15px;
        width: 22px;
        height: 16px;
        line-height: 16px;
        background-color: #e83030;
        color: #fff;
        border-radius: 8px;
        text-align: center;
        font-size: 12px;
      }
      .cartList {
        display: none;
        position: absolute;
        top: 40px;
        left: -161px;
        width: 306px;
        height: 55px;
        border: 1px solid #a77c5a;
        background: #edfff6;
        .empty_cart {
          margin-top: 9px;
          .cart_pop {
            width: 250px;
            height: 38px;
            line-height: 38px;
            margin: auto;
            color: #a77c5a;
            font-size: 12px;
            vertical-align: middle;
            .cart_img {
              width: 45px;
              height: 38px;
            }
            span {
              transform: translate(5px, -10px);
            }
          }
        }
      }
    }
    .search-shopCar:hover {
      border: 1px solid #a77c5a;
      border-bottom: none;
    }
  }
}
</style>
